import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

interface IconExtProps extends IconProps {
  dark?: boolean;
}

export const TransIcon: React.FC<IconExtProps> = (props) => {
  const color = props.dark ? "#0275D8" : "#5F738C";
  return (
    <Icon w="24px" h="24px" viewBox="0 0 24 24" {...props}>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 2H17C18.5977 2 19.9037 3.24892 19.9949 4.82373L20 5L20.0009 8.17102C21.1656 8.58312 22 9.69412 22 11V13C22 14.3059 21.1656 15.4169 20.0009 15.829L20 19C20 20.5977 18.7511 21.9037 17.1763 21.9949L17 22H5C3.40232 22 2.09634 20.7511 2.00509 19.1763L2 19V5C2 3.40232 3.24892 2.09634 4.82373 2.00509L5 2H17H5ZM17 4H5C4.48716 4 4.06449 4.38604 4.00673 4.88338L4 5V19C4 19.5128 4.38604 19.9355 4.88338 19.9933L5 20H17C17.5128 20 17.9355 19.614 17.9933 19.1166L18 19V16H17C15.3431 16 14 14.6569 14 13V11C14 9.34315 15.3431 8 17 8H18V5C18 4.48716 17.614 4.06449 17.1166 4.00673L17 4ZM19 10H17C16.4477 10 16 10.4477 16 11V13C16 13.5523 16.4477 14 17 14H19C19.5523 14 20 13.5523 20 13V11C20 10.4477 19.5523 10 19 10Z"
        fill={color}
      />
    </Icon>
  );
};
